<section>
  <div mat-dialog-title>
    <h1 fxFlexAlign="start">Vincular Região</h1>
    <div class="box"
         fxLayout="row"
         fxLayoutAlign="space-between center">
      <span class="box-text">Selecione a região que você deseja vincular.</span>
    </div>
  </div>

  <mat-dialog-content fxLayout="column"
                      fxLayoutAlign="start start">
    <form [formGroup]="regionForm"
          class="w-100">
      <div class="pos-relative"
           fxFlex.xs="100%"
           fxFlex.gt-xs="90%">
        <app-region-autocomplete class="auto-complete"
                                 formControlName="regionControl"
                                 [fControl]="regionForm.controls.regionControl">
        </app-region-autocomplete>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      fxLayout="row"
                      fxLayoutAlign="space-between center">
    <button mat-dialog-close
            mat-stroked-button>
      <mat-icon>close</mat-icon>
      <span>CANCELAR</span>
    </button>

    <button color="primary"
            mat-raised-button
            type="submit"
            (click)="select()">
      <mat-icon>check</mat-icon>
      <span>VINCULAR</span>
    </button>

  </mat-dialog-actions>
</section>
